export function getCssVar(name, fallback = "") {
    if (typeof document === "undefined")
        return fallback;
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
}

export function getPrimaryColor() {
    return getCssVar("--van-primary-color", "#fc7731");
}
